import React, { useState } from 'react';
import { getProducts } from '../../../../../services/affiliate.service';
import { NotificationManager } from 'react-notifications';
import { useDebounce } from '../../../../../hooks/useDebounce';
import SearchInput from '../../../../common-components/InputComponent/SearchInput';
import SearchIcon from '../../../../Icons/icons/SearchIcon';
import '../../styles/pay-with-product.scss';
import CustomCheckbox from '../../../../common-components/CustomCheckbox/CustomCheckbox';
import ThreeDotsLoader from '../../../../common-components/Loaders/ThreeDotsLoader';
import { getCurrencyLogo } from '../../../../../utils/global';
import { useSelector } from 'react-redux';
import ButtonComponent from '../../../../common-components/ButtonComponent/ButtonComponent';
import SelectedProductPreview from './SelectedProductPreview';

const PayWithProducts = ({
  selectedProduct,
  setSelectedProduct,
  setIsSelectVariantOpen,
  quantities,
  allOptions,
  getVariantDetails,
}) => {
  const [productSearchQuery, setProductSearchQuery] = useState('');
  const [searchProductLoading, setSearchProductLoading] = useState(false);
  const [products, setProducts] = useState([]);

  const searchProducts = async () => {
    if (productSearchQuery.length === 0) return;
    setSearchProductLoading(true);
    const response = await getProducts(productSearchQuery);
    if (response?.status) {
      setProducts(response?.data);
    } else {
      if (response?.data === 'Please connect GoAffPro app from setting.') {
      } else {
        NotificationManager.error(
          response?.message || 'Something went wrong.',
          '',
          1200,
        );
      }
    }
    setSearchProductLoading(false);
  };

  useDebounce(searchProducts, 300, [productSearchQuery]);

  const addProduct = (product) => {
    setSelectedProduct((prev) => [...prev, product]);
  };

  const removeProduct = (product) => {
    const removedProducts = selectedProduct.filter((p) => p.id !== product.id);
    setSelectedProduct([...removedProducts]);
  };

  return (
    <div className="sl-search-product-container">
      <SearchInput
        placeholder="Search Products"
        closeDropdown={() => {
          setProductSearchQuery('');
          setProducts([]);
          if (selectedProduct.length) {
            setIsSelectVariantOpen(true);
          }
        }}
        dropDownElement={({ item, key }) => (
          <SearchProductPreview
            key={item.id}
            item={item}
            addProduct={addProduct}
            removeProduct={removeProduct}
            selected={Boolean(selectedProduct.find((v) => v.id === item.id))}
          />
        )}
        dropDownItems={products}
        leftIcon={<SearchIcon />}
        value={productSearchQuery}
        onChange={(e) => setProductSearchQuery(e.target.value)}
        rightIcon={
          searchProductLoading ? (
            <ThreeDotsLoader color="#7357e9" style={{ height: '20px' }} />
          ) : (
            <></>
          )
        }
        dropDownMaxHeight="200px"
      />

      <SelectedProductPreview
        selectedProduct={selectedProduct}
        quantities={quantities}
        allOptions={allOptions}
        setIsSelectVariantOpen={setIsSelectVariantOpen}
        getVariantDetails={getVariantDetails}
      />
      {selectedProduct?.length ? (
        <div style={{ width: '100%' }}>
          <ButtonComponent
            variant="primary-outline"
            style={{ width: '100%' }}
            onClick={() => setIsSelectVariantOpen(true)}
          >
            Select Specific Variant
          </ButtonComponent>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

const SearchProductPreview = ({
  item,
  addProduct,
  removeProduct,
  selected,
}) => {
  const { userDetails } = useSelector((state) => state.user);

  return (
    <div className="sl-search-product-preview-container">
      <div className="sl-search-product-preview-content">
        <div className="sl-search-product-image">
          <img src={item?.image} alt="" />
        </div>
        <div className="sl-search-product-text">
          <div className="sl-search-product-name">{item.name}</div>
          <div className="sl-search-product-currency">
            {getCurrencyLogo(userDetails?.defaultCurrency)}
            {item.price}
          </div>
        </div>
      </div>
      <label>
        <CustomCheckbox
          checked={selected}
          onChange={(e) => {
            if (e.target.checked) addProduct(item);
            else removeProduct(item);
          }}
        />
      </label>
    </div>
  );
};

export default PayWithProducts;
